import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=a645b8d8&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=a645b8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a645b8d8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/customer/banner.vue
// module id = null
// module chunks = 